import { withEditCamperForm } from 'components/account/Campers/Edit'

// presentational component
import UI from './UI'

export default withEditCamperForm({
  redirect: '/campers'
})(UI)
